import {
  WSCard,
  WSElement,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import { IWorkLog, WorkLogStatus } from "@wingspanhq/payments/dist/interfaces";
import React, { useMemo } from "react";
import { StepItem, Steps } from "../../../shared/components/Steps";
import { useFeatureFlags } from "../../../query/hooks/useFeatureFlags";

type Props = {
  workLog?: IWorkLog;
  shimmer?: boolean;
};

export const WorkLogStatusStepperPayeeView: React.FC<Props> = props => {
  const featureFlags = useFeatureFlags();
  const isReviewWorkflow = featureFlags.data?.workLogReviewWorkflow;

  const steps: StepItem[] = useMemo(() => {
    const status = props.workLog?.status;
    const isApproved = status === WorkLogStatus.Approved;
    const isRejected = status === ("Rejected" as WorkLogStatus);
    const isInReview = status === ("InReview" as WorkLogStatus);
    const isDraftOrInProgress =
      status === WorkLogStatus.Draft ||
      status === ("InProgress" as WorkLogStatus);

    if (isReviewWorkflow) {
      let submittedStatus: StepItem["status"] = "Pending";
      if (isRejected) submittedStatus = "Rejected";
      else if (isInReview) submittedStatus = "Active";
      else if (isApproved) submittedStatus = "Complete";

      return [
        {
          title: "In-progress",
          status: isDraftOrInProgress ? "Active" : "Complete"
        },
        {
          title: "Submitted",
          status: submittedStatus
        },
        {
          title: "Approved",
          status: isApproved ? "Complete" : "Pending"
        }
      ];
    }

    return [
      {
        title: "In-progress",
        status: isApproved ? "Complete" : "Active"
      },
      {
        title: "Submitted",
        status: isApproved ? "Complete" : "Pending"
      }
    ];
  }, [props.workLog?.status, isReviewWorkflow]);

  return (
    <WSElement>
      <WSSectionToolbar title="Work log steps" />
      <WSCard shimmer={props.shimmer}>
        <Steps steps={steps} />
      </WSCard>
    </WSElement>
  );
};
